import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import WebriQForm from "@webriq/gatsby-webriq-form"

// import pdfIcon from "../images/pdf.png"

const ContactUs = () => (
  <Layout>
    <SEO
      title="Contact Us"
      description="Building Bridges to Your Possibilities."
    />
    <div className="container-fluid page-head about-us text-center">
      <div className="container p-relative page-heading">
        <div>
          <h1 className="inner-page-h1 font-weight-bold">Contact Us</h1>
        </div>
      </div>
      <div className="row heading-blocks"></div>
    </div>
    <div className="page-body" style={{ maxWidth: "1140px", margin: "0 auto" }}>
      <div className="row">
        <div className="col-lg-9 mx-auto">
          <div className="contact-clean w-100" style={{ paddingTop: "0" }}>
            <WebriQForm
              name="Contact Form"
              className="webriq-form w-100"
              data-form-id="f7fe1da0-3c14-4441-b65b-4916db880444"
              data-thankyou-url="/thank-you"
              style={{ maxWidth: "600px" }}
            >
              <h2 className="mt-2">Let's Talk</h2>

              <div className="form-group">
                <input
                  type="text"
                  name="Name"
                  className="form-control"
                  id="InputName"
                  placeholder="Enter Name"
                />
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group mt-0">
                    <input
                      type="email"
                      name="Email Address"
                      className="form-control"
                      id="InputEmail1"
                      aria-describedby="emailHelp"
                      placeholder="Enter email"
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mt-0">
                    <input
                      type="text"
                      name="Phone Number"
                      className="form-control"
                      id="InputPhone"
                      placeholder="Enter phone"
                    />
                  </div>
                </div>
              </div>

              <div className="ml-3">
                <label>What will we be discussing?</label>
                <br />
                <div className="d-flex align-items-center">
                  <input type="radio" name="Discussion" value="Business" />
                  <span className="ml-2">Business</span>
                </div>
                <div className="d-flex align-items-center">
                  <input type="radio" name="Discussion" value="Personal" />
                  <span className="ml-2">Personal</span>
                </div>
                <div className="d-flex align-items-center">
                  <input type="radio" name="Discussion" value="Both" />
                  <span className="ml-2">Both</span>
                </div>
                <div className="d-flex align-items-center">
                  <input
                    type="radio"
                    name="Discussion"
                    value="Other
                Inquiries"
                  />
                  <span className="ml-2">Other Inquiries</span>
                </div>
              </div>

              <div className="ml-3">
                <label>How soon are you looking to start?</label>
                <br />
                <div className="d-flex align-items-center">
                  <input type="radio" name="When to start" value="Business" />
                  <span className="ml-2">ASAP</span>
                </div>
                <div className="d-flex align-items-center">
                  <input type="radio" name="When to start" value="1-2 Months" />
                  <span className="ml-2">1-2 Months</span>
                </div>
                <div className="d-flex align-items-center">
                  <input type="radio" name="When to start" value="2+ Months" />
                  <span className="ml-2">2+ Months</span>
                </div>
                <div className="d-flex align-items-center">
                  <input
                    type="radio"
                    name="When to start"
                    value="Other
                Inquiries"
                  />
                  <span className="ml-2">Not Applicable / Not Sure</span>
                </div>
              </div>

              <div className="form-group m-0">
                <label
                  className="position-relative mb-4 text-capitalize mt-0"
                  style={{ lineHeight: "1.5" }}
                >
                  How Important is it to make a change in your life or business?
                </label>
                <select
                  className="form-control"
                  name="How Important Is It To Make A Change In Your Life Or Business?"
                  required
                >
                  <option
                    value=""
                    default=""
                    style={{ display: "none" }}
                    disabled=""
                  >
                    Choose an option
                  </option>
                  <option value="Not Applicable">Not Applicable</option>
                  <option value="Not Important">Not Important</option>
                  <option value="A Little Important">A Little Important</option>
                  <option value="Very Important">Very Important</option>
                </select>
              </div>
              <div className="form-group m-0">
                <label
                  className="position-relative mb-4 text-capitalize mt-0"
                  style={{ lineHeight: "1.5" }}
                >
                  Are you seeking one-time help, or ongoing consultation?
                </label>
                <select
                  className="form-control"
                  name="Are You Seeking One-Time Help, Or Ongoing Consultation?"
                  required
                >
                  <option
                    value=""
                    default=""
                    style={{ display: "none" }}
                    disabled=""
                  >
                    Choose an option
                  </option>
                  <option value="Ongoing">Ongoing</option>
                  <option value="One Time">One Time</option>
                  <option value="Not Sure Yet">Not Sure Yet</option>
                  <option value="Not Applicable">Not Applicable</option>
                </select>
              </div>

              <div className="form-group">
                <textarea
                  name="Message"
                  className="form-control h-auto"
                  id="InputMessage"
                  rows={4}
                  placeholder="Add a comment"
                />
              </div>
              <div className="form-group">
                <div className="webriq-recaptcha" />
              </div>
              <button
                type="submit"
                className="btn-global w-100 hvr-bounce-to-right"
              >
                Submit
              </button>
            </WebriQForm>
          </div>
        </div>
        <div className="col-lg-6"></div>
      </div>
    </div>
  </Layout>
)

export default ContactUs
